import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { AudioPlaylistPlayerComponent } from './audio-playlist-player.component';

@NgModule({
   declarations: [AudioPlaylistPlayerComponent],
   exports: [AudioPlaylistPlayerComponent],
   imports: [
      DragDropModule,
      FormsModule,
      CommonModule,
      ReactiveFormsModule,
      MatIconModule,
      MatTooltipModule,
      MatButtonModule,
      FileUrlPipeModule,
      MatMenuModule,
      LcsLoadingOverlayModule,
      MatSliderModule,
   ],
})
export class AudioPlaylistPlayerModule {}
